export default {
    getMoment: function (dateCreated) {
        let tsc = Date.parse(new Date()) - dateCreated; // Time Since Created
        if(tsc < 60*1000) {
            return 'just now';
        } else if (tsc > 60*1000 && tsc < 3600*1000) {
            return Math.round(tsc / (60*1000)) + 'm ago';
        } else if (tsc > 3600*1000 && tsc < 86400*1000) {
            return Math.round(tsc / (6*1000*1000)) + 'h ago';
        } else if (tsc > 86400*1000 && tsc < 172800*1000) {
            return '1 day ago';
        } else {
            return formatDate(dateCreated);
        }
    }
}

function formatDate(dateCreated) {
    const date = new Date(dateCreated);
    const now = new Date();
    const options = { month: 'long', day: 'numeric' }; // Default options for the current year

    // Check if the year of the date is not the current year
    if (date.getFullYear() !== now.getFullYear()) {
        options.year = 'numeric'; // Add year to the options if it's not the current year
    }

    return date.toLocaleDateString('en-US', options);
}

export function timeAgo(dateString) {
    const now = new Date();
    const past = new Date(dateString);
    const diffMs = now - past;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const weeks = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 7));
    const months = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 30));
    const years = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 365));

    if (seconds < 60) return `${seconds} sec${seconds !== 1 ? 's' : ''} ago`;
    if (minutes < 60) return `${minutes} min${minutes !== 1 ? 's' : ''} ago`;
    if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    if (days < 7) return `${days} day${days !== 1 ? 's' : ''} ago`;
    if (weeks < 5) return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
    if (months < 12) return `${months} month${months !== 1 ? 's' : ''} ago`;
    return `${years} year${years !== 1 ? 's' : ''} ago`;
}